import { Component, Input } from '@angular/core';

import { BaseSkeletonEnum } from '@shared/enums/skeleton.enum';

@Component({
  selector: 'app-base-skeleton',
  templateUrl: './base-skeleton.component.html'
})
export class BaseSkeletonComponent {
  @Input() type: BaseSkeletonEnum.TABLE_VIEW | BaseSkeletonEnum.CARD_VIEW |BaseSkeletonEnum.AVATARS;
  BaseSkeletonEnum = BaseSkeletonEnum;
}
